import { Component, OnInit } from '@angular/core';
import { MessagesStoreService } from '../../services/messages-store.service';
import { Observable } from 'rxjs';
import { Message } from '../../models/messages.model';
import { HandsetService } from '../../../core/services/handset.service';

@Component({
standalone: false,
  selector: 'app-dialog-msg',
  templateUrl: './dialog-msg.component.html',
  styleUrls: ['./dialog-msg.component.scss'],
})
export class DialogMsgComponent implements OnInit {
  public message$: Observable<Message>;
  public state: Message;
  public phoneNumber = '222610620';
  public mail = 'kontakt@payka.pl';

  constructor(private messagesStoreSevice: MessagesStoreService, public handsetService: HandsetService) {
  }

  ngOnInit() {
    this.message$ = this.messagesStoreSevice.state$;
    this.state = this.messagesStoreSevice.state;
  }

  onYesClick() {
    this.state.onYes();
    this.messagesStoreSevice.setState(null);
  }

  onNoClick() {
    this.state.onNo();
    this.messagesStoreSevice.setState(null);
  }

  onSaveClick() {
    this.state.onSave();
    this.messagesStoreSevice.setState(null);
  }

  onCancelClick() {
    this.state.onCancel();
    this.messagesStoreSevice.setState(null);
  }


  onCallClick() {
    window.location.href = `tel:${this.phoneNumber}`;
  }

  public onReportClick(): void {
    const message =
      'Cześć, proszę o sprawdzenie błędu ' +
      (this.messagesStoreSevice.state.errorHash !== null ? this.messagesStoreSevice.state.errorHash : '...') +
      ', napotkanego podczas korzystania z aplikacji.';

    window.location.href = 'mailto:' + this.mail + '?subject=' + 'Błąd' + '&body=' + message;

  }

}
